import { Link } from "react-router-dom";

import { Pill } from "../Pill";
import type { Task } from "../../types";

interface Props {
  tasks: Task[];
}

/** The contact's open tasks; each opens in the task drawer on /tasks. */
export function OpenTasksPanel({ tasks }: Props) {
  return (
    <div className="panel panel--flush">
      <div className="panel-header">
        <h3>Open tasks</h3>
      </div>
      <div className="panel-body">
        {tasks.length === 0 ? (
          <p className="text-sm text-ink-low">No open tasks.</p>
        ) : (
          <ul
            className="divide-y -mx-6"
            style={{ borderColor: "var(--c-rule)" }}
          >
            {tasks.slice(0, 10).map((t) => (
              <li
                key={t.id}
                className="px-6 py-2 flex items-center justify-between gap-2"
              >
                <Link className="text-sm link" to={`/tasks?task=${t.id}`}>
                  {t.data.subject || t.data.task_type}
                </Link>
                <Pill value={t.data.status} />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
